"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_DVR_WINDOW = exports.PLAYER_OPTIONS = void 0;
exports.PLAYER_OPTIONS = {
    autoplay: true,
    muted: false,
    preferredFormats: ["dash", "hls", "mp4", "mp3"],
    keysystem: undefined,
};
if (process.env.NODE_ENV === "development") {
    if (window.__RED_BEE_MEDIA__) {
        exports.PLAYER_OPTIONS.preferredFormats = window.__RED_BEE_MEDIA__.preferredFormats;
    }
}
exports.MIN_DVR_WINDOW = 90; // min seconds for a live asset to be considered seekable.
//# sourceMappingURL=defaults.js.map